"use strict";

exports.__esModule = true;
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

var Semaphoreci = function Semaphoreci(props) {
  var color = props.color,
      size = props.size,
      others = _objectWithoutPropertiesLoose(props, ["color", "size"]);

  return _react.default.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size,
    fill: color,
    viewBox: "0 0 24 24"
  }, others), _react.default.createElement("path", {
    d: "M21.864 5.266a.595.595 0 01.61.257s.467.76.744 1.365c.275.604.542 1.453.542 1.453a.592.592 0 01-.208.628l-1.505 1.073a.757.757 0 00-.284.646s.084.573.096 1.066c.01.485-.04 1.045-.04 1.045a.752.752 0 00.316.628l1.561.993c.192.122.3.398.24.618 0 0-.222.862-.467 1.48-.242.62-.668 1.4-.668 1.4a.592.592 0 01-.595.287l-1.819-.337a.76.76 0 00-.66.245s-.381.489-.754.861c-.414.415-.997.857-.997.857a.76.76 0 00-.254.658l.306 1.824a.592.592 0 01-.298.59s-.79.412-1.414.645c-.623.233-1.488.44-1.488.44a.592.592 0 01-.61-.251l-.967-1.576a.756.756 0 00-.624-.328s-.496.04-.949.025c-.466-.015-.986-.09-.986-.09a.754.754 0 00-.646.281L8.97 23.555a.593.593 0 01-.628.207s-.85-.267-1.456-.543c-.605-.276-1.362-.74-1.362-.74a.592.592 0 01-.256-.61l.385-1.599c.08-.331.338-.796.579-1.037l3.98-3.993a3.7 3.7 0 005.026-5.025l3.988-3.989c.241-.24.705-.5 1.036-.579zM2.134 18.733a.595.595 0 01-.61-.257s-.467-.758-.743-1.364c-.276-.605-.543-1.453-.543-1.453a.592.592 0 01.207-.628l1.506-1.073a.757.757 0 00.283-.646s-.082-.573-.095-1.066c-.01-.485.04-1.046.04-1.046a.752.752 0 00-.316-.628L.303 9.58a.592.592 0 01-.241-.617S.285 8.1.528 7.48c.244-.617.67-1.4.67-1.4a.592.592 0 01.594-.286l1.819.337a.76.76 0 00.661-.244s.38-.489.753-.862c.414-.414.997-.855.997-.855a.76.76 0 00.254-.66L5.97 1.688a.592.592 0 01.298-.591S7.058.685 7.682.45C8.305.219 9.17.012 9.17.012a.592.592 0 01.612.25l.966 1.578a.756.756 0 00.624.326s.496-.039.949-.024c.466.015.986.091.986.091a.754.754 0 00.646-.283L15.028.445a.593.593 0 01.628-.208s.85.268 1.456.544c.605.275 1.362.74 1.362.74a.593.593 0 01.256.61l-.385 1.599a2.59 2.59 0 01-.578 1.036L13.786 8.76a3.7 3.7 0 00-5.026 5.026l-3.988 3.987c-.24.242-.705.5-1.036.58z"
  }));
};

Semaphoreci.propTypes = {
  /**
   * Hex color or color name
   */
  color: _propTypes.default.string,

  /**
   * The size of the Icon.
   */
  size: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.number])
};
Semaphoreci.defaultProps = {
  color: 'currentColor',
  size: '24'
};
var _default = Semaphoreci;
exports.default = _default;